module.exports = __webpack_public_path__ + "img/logout.0ae026ff.svg";